import { CSSProperties } from "react";

import { ConnectionIssueIcon } from "./connection_issue_icon";
import { WarningIcon } from "./warning_icon";

export function AvIssueIcon({
  poorConnection,
  title,
  displayTitle = false,
  size = 16,
  style = {},
}: {
  poorConnection?: boolean;
  title: string;
  displayTitle?: boolean;
  size?: number;
  style?: CSSProperties;
}) {
  return (
    <div className="flex items-center" title={title} style={style}>
      {poorConnection ? (
        <ConnectionIssueIcon width={size} height={size} />
      ) : (
        <WarningIcon width={size} height={size} />
      )}
      {displayTitle && <span className="ml2">{title}</span>}
    </div>
  );
}
